import { PublicQuestion } from "@/queries/types";
import styled from "@emotion/styled";
import {
  Content,
  DSTextOption as SystemTextOption,
  DSTextOptionsAnswer as SystemTextOptionsAnswer,
} from "@hundred5/design-system";
import { Trans } from "@lingui/react/macro";
import { Dispatch } from "react";
import * as amplitude from "../../../../amplitude";
import { Markdown } from "../../../markdown";
import { Action, State } from "../../reducer";
import { sortOptions } from "../utils";

interface Props {
  question: PublicQuestion;
  state: State;
  dispatch: Dispatch<Action>;
}

export function MultipleOptionsAnswer({ state, dispatch, question }: Props) {
  const answer = state.answers[question.test_question_id];

  return (
    <>
      <Note>
        <Trans>Select all that apply</Trans>
      </Note>
      <SystemTextOptionsAnswer>
        {sortOptions(question?.options || []).map((option) => {
          const optionId = (
            option.test_question_option_id || option.library_question_option_id
          )?.toString();
          return (
            <SystemTextOption
              key={optionId}
              type="multiple"
              name={`answer-${question.test_question_id}`}
              id={`option-${question.test_question_id}-${optionId}`}
              selected={
                answer != null &&
                answer.chosenOptions.findIndex(
                  (chosenOption: { optionId: string }) =>
                    chosenOption.optionId === optionId,
                ) !== -1
              }
              disabled={state.submitting}
              onChange={(selected) => {
                dispatch({
                  type: "select_multiple_option_answer",
                  payload: {
                    optionId: optionId!,
                    questionId: question.test_question_id.toString(),
                    selected,
                  },
                });

                amplitude.trackQuestionAnswer(
                  state.jobOpeningSlug,
                  state.activeQuestionIndex,
                );
              }}
            >
              <ContentWrapper>
                <Content>
                  <Markdown>{option.content}</Markdown>
                </Content>
              </ContentWrapper>
            </SystemTextOption>
          );
        })}
      </SystemTextOptionsAnswer>
    </>
  );
}

//region Styles
const ContentWrapper = styled.div`
  margin-top: -10px;
  margin-bottom: -10px;
`;

const Note = styled.div`
  overflow: hidden;
  font-size: 12px;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: ${(props) => props.theme.colors.purple[60]};
  margin-bottom: 20px;
`;
//endregion
